module.exports = __webpack_public_path__ + "static/media/history3.5c8d88a0.jpg";